<template lang="pug">
  table.reach-info
    tr
      td.number.potential {{ $t('fn.number', { value: maxReach }) }}
      td {{ $t('pos.offer.potentital-total') }}
    tr
      td.number.guaranteed {{ $t('fn.number', { value: minReach }) }}
      td {{ $t('pos.offer.guaranteed') }}
    tr
      td.number.not-reached {{ $t('fn.number', { value: maxReach - minReach }) }}
      td {{ $t('pos.offer.not-reached') }}
</template>

<script>
export default {
  props: {
    maxReach: Number,
    minReach: Number,
  },
};
</script>



// WEBPACK FOOTER //
// ReachInfo.vue?ee364886